import React, { FC, ReactNode } from 'react'
interface IProps {
  children?: ReactNode
}

const Container: FC<IProps> = ({ children }) =>
  children ? <div>{children}</div> : <div />

export default Container
